import { render, staticRenderFns } from "./AdditionalCost.vue?vue&type=template&id=a406ea6c&scoped=true"
import script from "./AdditionalCost.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdditionalCost.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdditionalCost.vue?vue&type=style&index=0&id=a406ea6c&prod&scoped=true&lang=css"
import style1 from "./AdditionalCost.vue?vue&type=style&index=1&id=a406ea6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a406ea6c",
  null
  
)

export default component.exports